if (!customElements.get('footer-component')) {
  customElements.define(
    'footer-component',
    class FooterComponent extends HTMLElement {
      constructor() {
        super();
      }
      
      connectedCallback() {
        this.handleDropDownFooter();
      }

      handleDropDownFooter() {
        const footerDropdownHeaders = this.querySelectorAll('.footer-custom__top-footer-menu-dropdown-header');
        footerDropdownHeaders.forEach((header) => {
          header.addEventListener('click', () => {
            const parent = header.closest('.footer-custom__top-footer-menu-container');
            parent.classList.toggle('footer-custom__top-footer-menu-container--open');
          });
        });
      }
    }
  );
}
